import { Grid } from "@mui/material";
import FieldDisplay from "components/FieldDisplay";
import * as fields from "pages/clientPortfolio/businessClient/businessClientAccounts/businessSavingsFieldDefinitions";
import { BusinessSavings } from "types";
import AccountDisplayTemplate from "pages/clientPortfolio/businessClient/businessClientAccounts/components/AccountDisplayTemplate";

export type Props = {
  account: BusinessSavings;
  onEditClick(): void;
  onDeleteClick(): void;
  onAccountHistoryClick(): void;
  isReadOnlyView: boolean;
};

function BusinessSavingsDisplay({
  account,
  onEditClick,
  onDeleteClick,
  onAccountHistoryClick,
  isReadOnlyView,
}: Props) {
  const commonProps = {
    state: account,
  };

  return (
    <AccountDisplayTemplate
      id={`BUSINESS_SAVINGS_${account.accountId}_header`}
      onEditClick={onEditClick}
      onDeleteClick={onDeleteClick}
      onAccountHistoryClick={onAccountHistoryClick}
      accountType="Savings"
      accountNumber={account.accountNumber || ""}
      balance={account.balance || 0}
      isReadOnlyView={isReadOnlyView}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FieldDisplay<BusinessSavings>
            field={fields.businessSavingsAccounNumber}
            {...commonProps}
          />
          <FieldDisplay<BusinessSavings>
            field={fields.businessSavingsBalance}
            {...commonProps}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldDisplay<BusinessSavings>
            field={fields.businessSavingsOpenDate}
            {...commonProps}
          />
          <FieldDisplay<BusinessSavings>
            field={fields.businessSavingsCloseDate}
            {...commonProps}
          />
        </Grid>
      </Grid>
    </AccountDisplayTemplate>
  );
}

export default BusinessSavingsDisplay;
